/**
 * donde-esta-mi-pedido.js
 *
 * Añadir en theme.liquid con:
 *   <script src="{{ 'donde-esta-mi-pedido.js' | asset_url }}" defer></script>
 *
 * Llama al endpoint /order-status del mismo Worker que ya manda los avisos
 * de cambio de fecha. Nunca consulta la Admin API de Shopify directamente
 * desde el navegador (el token es secreto).
 */
(function () {
  function getContenedor() {
    return document.querySelector("[data-donde-mi-pedido]");
  }

  function formatearFecha(fechaISO, locale) {
    const [y, m, d] = fechaISO.split("-").map(Number);
    const fecha = new Date(y, m - 1, d);
    return new Intl.DateTimeFormat(locale || undefined, {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(fecha);
  }

  function mostrarSoloUno(contenedor, cual) {
    const estados = ["cargando", "error", "resultado"];
    estados.forEach((nombre) => {
      const el = contenedor.querySelector(`[data-dmp-${nombre}]`);
      if (el) el.hidden = nombre !== cual;
    });
  }

  function pintarPasos(contenedor, data) {
    const tieneTrackings = data.trackings && data.trackings.length > 0;

    // "confirmado" siempre completado si hemos llegado hasta aquí (el
    // pedido existe). "preparacion" pasa a completado en cuanto haya algo
    // enviado (total o parcial). "enviado" es activo si es un envío
    // parcial (aún queda algo por salir) o completado si ya salió todo.
    const estadoPreparacion = data.completamenteEnviado || tieneTrackings ? "completado" : "activo";
    const estadoEnviado = data.completamenteEnviado
      ? "completado"
      : tieneTrackings
      ? "activo"
      : "pendiente";

    const estados = { confirmado: "completado", preparacion: estadoPreparacion, enviado: estadoEnviado };

    Object.keys(estados).forEach((paso) => {
      const el = contenedor.querySelector(`[data-dmp-paso="${paso}"]`);
      if (!el) return;
      el.classList.remove("dmp__paso--completado", "dmp__paso--activo");
      const circulo = el.querySelector("[data-dmp-circulo]");
      if (estados[paso] === "completado") {
        el.classList.add("dmp__paso--completado");
        if (circulo) circulo.textContent = "✓";
      } else {
        // Importante: si se ha consultado antes otro pedido más avanzado
        // en esta misma página (sin recargar), el círculo puede haberse
        // quedado con el "✓" de esa búsqueda anterior — siempre hay que
        // devolverlo a su número original salvo que esté completado.
        if (estados[paso] === "activo") el.classList.add("dmp__paso--activo");
        if (circulo) circulo.textContent = circulo.getAttribute("data-numero");
      }
    });

    const linea1 = contenedor.querySelector('[data-dmp-linea="1"]');
    const linea2 = contenedor.querySelector('[data-dmp-linea="2"]');
    if (linea1) linea1.classList.add("dmp__paso-linea--completada"); // "confirmado" siempre completado
    if (linea2) linea2.classList.toggle("dmp__paso-linea--completada", estadoEnviado !== "pendiente");
  }

  function pintarResultado(contenedor, data) {
    const locale = document.documentElement.lang || undefined;
    const esIngles = (document.documentElement.lang || "").indexOf("en") === 0;
    const bloqueFecha = contenedor.querySelector("[data-dmp-bloque-fecha]");
    const bloqueTrackings = contenedor.querySelector("[data-dmp-bloque-trackings]");
    const bloqueTransferencia = contenedor.querySelector("[data-dmp-bloque-transferencia]");
    const bloqueCancelado = contenedor.querySelector("[data-dmp-bloque-cancelado]");
    const contenidoNormal = contenedor.querySelector("[data-dmp-contenido-normal]");
    const badgeReembolso = contenedor.querySelector("[data-dmp-badge-reembolso]");
    const notaNormal = contenedor.querySelector("[data-dmp-nota-normal]");
    const notaTransferencia = contenedor.querySelector("[data-dmp-nota-transferencia]");
    const listaTrackings = contenedor.querySelector("[data-dmp-lista-trackings]");
    const plantilla = document.querySelector("[data-dmp-plantilla-tracking]");
    const numeroPedidoEl = contenedor.querySelector("[data-dmp-numero-pedido]");

    if (numeroPedidoEl) numeroPedidoEl.textContent = data.numeroPedido;

    // Pedido cancelado: se sustituye TODO el contenido habitual (pasos,
    // fecha, tracking) por un único bloque de aviso — no tiene sentido
    // mostrar un indicador de progreso ni una fecha de entrega de un
    // pedido que no va a llegar.
    if (bloqueCancelado) bloqueCancelado.hidden = !data.cancelado;
    if (contenidoNormal) contenidoNormal.hidden = !!data.cancelado;

    if (badgeReembolso) {
      if (data.estadoPago === "REFUNDED") {
        badgeReembolso.textContent = esIngles ? "Refunded" : "Reembolsado";
        badgeReembolso.hidden = false;
      } else if (data.estadoPago === "PARTIALLY_REFUNDED") {
        badgeReembolso.textContent = esIngles ? "Partially refunded" : "Reembolso parcial";
        badgeReembolso.hidden = false;
      } else {
        badgeReembolso.hidden = true;
      }
    }

    if (data.cancelado) return; // nada más que pintar en este caso

    pintarPasos(contenedor, data);

    if (listaTrackings) listaTrackings.innerHTML = "";

    if (!data.completamenteEnviado && data.fechaEntrega) {
      const fechaEl = contenedor.querySelector("[data-dmp-fecha]");
      if (fechaEl) fechaEl.textContent = formatearFecha(data.fechaEntrega, locale);
      if (bloqueFecha) bloqueFecha.hidden = false;
      // Si el pago está pendiente por transferencia, se cambia la nota de
      // debajo de la fecha por el aviso de posible demora, y se muestra
      // el bloque con los datos bancarios justo después.
      if (notaNormal) notaNormal.hidden = !!data.pendienteTransferencia;
      if (notaTransferencia) notaTransferencia.hidden = !data.pendienteTransferencia;
    } else if (bloqueFecha) {
      bloqueFecha.hidden = true;
    }

    if (bloqueTransferencia) {
      if (data.pendienteTransferencia) {
        const refElemento = contenedor.querySelector("[data-dmp-numero-pedido-transferencia]");
        if (refElemento) refElemento.textContent = data.numeroPedido;
        bloqueTransferencia.hidden = false;
      } else {
        bloqueTransferencia.hidden = true;
      }
    }

    if (listaTrackings && plantilla && data.trackings && data.trackings.length > 0) {
      const notaParcial = contenedor.querySelector("[data-dmp-nota-parcial]");
      if (notaParcial) notaParcial.hidden = data.estado !== "PARTIALLY_FULFILLED";

      const localeIdioma = document.documentElement.lang || "es";
      const esIngles = localeIdioma.indexOf("en") === 0;

      data.trackings.forEach((t) => {
        const nodo = plantilla.content.cloneNode(true);

        const empresaEl = nodo.querySelector("[data-empresa]");
        if (t.company) {
          empresaEl.textContent = t.company;
        } else {
          // Sin transportista informado: mejor ocultar el texto que
          // mostrar un guion suelto y feo — el envío puede seguir
          // teniendo enlace de seguimiento aunque no haya nombre.
          empresaEl.textContent = esIngles ? "Shipment" : "Envío";
        }

        const etiquetaNumero = nodo.querySelector("[data-dmp-etiqueta-numero]");
        const numeroEl = nodo.querySelector("[data-numero]");
        if (t.number) {
          numeroEl.textContent = t.number;
        } else {
          if (etiquetaNumero) etiquetaNumero.hidden = true;
          if (numeroEl) numeroEl.hidden = true;
        }

        const listaProductos = nodo.querySelector("[data-productos]");
        if (listaProductos && t.productos && t.productos.length > 0) {
          t.productos.forEach((p) => {
            const li = document.createElement("li");
            li.textContent = p.cantidad > 1 ? `${p.titulo} (x${p.cantidad})` : p.titulo;
            listaProductos.appendChild(li);
          });
          listaProductos.hidden = false;
        }

        const enlace = nodo.querySelector("[data-enlace]");
        if (t.url) {
          enlace.href = t.url;
          enlace.hidden = false;
        }
        listaTrackings.appendChild(nodo);
      });
      if (bloqueTrackings) bloqueTrackings.hidden = false;
    } else if (bloqueTrackings) {
      bloqueTrackings.hidden = true;
    }

    const bloqueEliminados = contenedor.querySelector("[data-dmp-bloque-eliminados]");
    const listaEliminados = contenedor.querySelector("[data-dmp-lista-eliminados]");
    const plantillaEliminado = document.querySelector("[data-dmp-plantilla-eliminado]");
    if (listaEliminados) listaEliminados.innerHTML = "";

    if (
      listaEliminados &&
      plantillaEliminado &&
      data.productosEliminados &&
      data.productosEliminados.length > 0
    ) {
      data.productosEliminados.forEach((p) => {
        const nodo = plantillaEliminado.content.cloneNode(true);
        const tituloEl = nodo.querySelector("[data-titulo]");
        if (tituloEl) {
          tituloEl.textContent = p.cantidad > 1 ? `${p.titulo} (x${p.cantidad})` : p.titulo;
        }
        listaEliminados.appendChild(nodo);
      });
      if (bloqueEliminados) bloqueEliminados.hidden = false;
    } else if (bloqueEliminados) {
      bloqueEliminados.hidden = true;
    }
  }

  function iniciar() {
    const contenedor = getContenedor();
    if (!contenedor) return;

    const endpoint = contenedor.getAttribute("data-endpoint");
    const formulario = contenedor.querySelector("[data-dmp-formulario]");
    const boton = contenedor.querySelector("[data-dmp-boton]");

    // Delegado en el contenedor (no en cada botón individual): los botones
    // de "Copiar" ya existen en el HTML desde el principio (no se generan
    // dinámicamente), así que esto es solo comodidad, pero delegar evita
    // tener que volver a engancharlos si el bloque se regenera.
    contenedor.addEventListener("click", async (evento) => {
      const botonCopiar = evento.target.closest("[data-dmp-copiar]");
      if (!botonCopiar) return;
      const iban = botonCopiar.getAttribute("data-dmp-copiar");
      try {
        await navigator.clipboard.writeText(iban);
        const textoOriginal = botonCopiar.textContent;
        botonCopiar.textContent = document.documentElement.lang === "en" ? "Copied!" : "¡Copiado!";
        setTimeout(() => {
          botonCopiar.textContent = textoOriginal;
        }, 1500);
      } catch (e) {
        console.error("donde-esta-mi-pedido: no se pudo copiar", e);
      }
    });

    formulario.addEventListener("submit", async (evento) => {
      evento.preventDefault();
      const email = contenedor.querySelector("#dmp-email").value.trim();
      const numeroPedido = contenedor.querySelector("#dmp-pedido").value.trim();
      if (!email || !numeroPedido) return;

      boton.disabled = true;
      mostrarSoloUno(contenedor, "cargando");

      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, numeroPedido }),
        });
        const data = await res.json();

        if (data.error) {
          mostrarSoloUno(contenedor, "error");
        } else {
          pintarResultado(contenedor, data);
          mostrarSoloUno(contenedor, "resultado");
        }
      } catch (e) {
        console.error("donde-esta-mi-pedido:", e);
        mostrarSoloUno(contenedor, "error");
      } finally {
        boton.disabled = false;
      }
    });
  }

  document.addEventListener("DOMContentLoaded", iniciar);
})();